import { Box, Card, Stack, Typography } from "@mui/material"
import { styleCard } from "../styles/styles"
import { Fragment, useEffect } from "react"
import { VideoPlayer } from "../../../modules/Player/VideoPlayer"



interface IVdeoDataProps {
    temperatureSrc?: string | null,
    pressureSrc?: string | null,
    fullSrc?: string | null,
    flipping?: boolean
    presStart?: number | null
    presEnd?: number | null
    tempStart?: number | null
    tempEnd?: number | null
    faceProcessingServiceResult?: any
}


export const VideoData = ({ temperatureSrc, pressureSrc, fullSrc, flipping, presStart, presEnd, tempStart, tempEnd, faceProcessingServiceResult }: IVdeoDataProps) => {
    const videoStyle = {
        minWidth: '416px', //'348px',
        // minHeight: '192px',
        borderRadius: '4px',
        backgroundColor: 'black',
    }
    const item = {
        display: 'flex',
        //width: '550px',
        width: '100%',
        height: '100%',
        // justifyContent: 'space-between',
        // wordWrap: 'wrap',
        gap: '24px',
    }
    const headerStyle = {
        //maxWidth: '200px'
        fontFamily: 'Roboto',
        fontWeight: '500',
        fontSize: '20px',
        lineHeight: '26px',
        wordWrap: 'wrap',
        width: '100%',
    }

    useEffect(()=>{
        console.log('video props')
        console.log(temperatureSrc)
        console.log(pressureSrc)
        console.log(fullSrc)
    }, [temperatureSrc, pressureSrc, fullSrc])


    return (
        <Box sx={
            {
                ...styleCard,
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
            }}>
            <Stack marginTop={1} spacing={'16px'} width={'100%'} height={'100%'}>
                  <Stack sx={{ width: '100%', aspectRatio: '4/3', gap: '16px' }}>
                      <Typography sx={headerStyle}>Полное видео осмотра</Typography>
                      <VideoPlayer
                          faceProcessingServiceResult={faceProcessingServiceResult}
                          url={fullSrc ?? undefined}
                          autoPlay={true} muted={true} flipping={flipping} style={{...videoStyle, width: '100%', height: '100%' }}
                      />
                  </Stack>
            </Stack>
        </Box>
    )
}